import CryptoJS from 'crypto-js';
import { curry } from 'ramda';

const crypto = {
  encrypt: curry((secretKey: string, value: string) => {
    return CryptoJS.AES.encrypt(value, secretKey).toString();
  }),
  decrypt: curry((secretKey: string, value: string) => {
    return CryptoJS.AES.decrypt(value, secretKey).toString(CryptoJS.enc.Utf8);
  }),
};

export default crypto;
